"use client";
import React from "react";
import { Sparkles, MousePointerClick, Zap } from "lucide-react";

export const DocsHero = () => {
    return (
        <div className="relative w-full overflow-hidden rounded-3xl bg-surface/40 backdrop-blur-md border border-border/50 p-8 lg:p-12 mb-12 group">
            {/* Background Effects */}
            <div className="absolute top-0 right-0 w-96 h-96 bg-primary/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 group-hover:bg-primary/20 transition-colors duration-700" />
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-secondary/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" />

            <div className="relative z-10 max-w-3xl">
                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 border border-primary/20 text-primary text-xs font-bold uppercase tracking-wider mb-6">
                    <Sparkles className="w-3 h-3" />
                    Interactive Documentation
                </div>

                <h1 className="text-4xl lg:text-6xl font-bold text-primary-text mb-6 leading-tight">
                    Learn by <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-purple-600">Doing</span>
                </h1>

                <p className="text-lg text-secondary-text leading-relaxed mb-8 max-w-2xl">
                    This isn't just static text. Every component below is a <span className="text-primary-text font-semibold">live playground</span>.
                    Click buttons, toggle settings, and chat with AI to understand exactly how the platform works before you even sign up.
                </p>

                <div className="flex flex-wrap gap-4">
                    <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-background/50 border border-border text-sm text-secondary-text">
                        <MousePointerClick className="w-4 h-4 text-primary" />
                        <span>Clickable Elements</span>
                    </div>
                    <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-background/50 border border-border text-sm text-secondary-text">
                        <Zap className="w-4 h-4 text-amber-500" />
                        <span>Live Reactivity</span>
                    </div>
                </div>
            </div>
        </div>
    );
};
